const validate = (state, formMetadata) => {
    let isValid = true,
        formState = {};

    Object.keys(formMetadata)
        .forEach(key => {
            const message = formMetadata[key].map(v => v(state[key])).find(m => m);
            if (message) {
                isValid = false;
                formState[key] = message;
            }
            else {
                formState[key] = null;
            }
        });

    if (isValid)
        return {isValid: true};

    return formState;
};

const regExp = {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

const required = message => (val => val ? null : (message || 'Введите значение'));
const addressRequired = message => (val => val && val.strictName ? null : (message || 'Укажите адрес'));
const phoneNumberRequired = message => (val => val.replace(/[^\d]/g, '').length === 10 ? null : (message || 'Введите номер телефона'));
const email = message => (val => !val || regExp.email.test(val.toLowerCase()) ? null : message);
const number = message => (val => !isNaN(parseFloat(val)) ? null : (message || 'Введите число'));
const min = (minVal, message) => (val => parseInt(val) >= minVal ? null : (message || 'Введите число'));
const conditional = (predicate, validator) => (val => predicate() ? validator(val) : null);

export {
    validate,
    required,
    addressRequired,
    phoneNumberRequired,
    email,
    number,
    min,
    conditional
}


// WEBPACK FOOTER //
// ./src/utils/validation.js